var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/lib/Feedback.tsx
import { useState } from "react";
import { Popover } from "@availity/mui-popover";
import { Button as Button2 } from "@availity/mui-button";
import Container from "@mui/material/Container";
import { styled as styled3 } from "@mui/material/styles";
import { avLogMessagesApiV2 } from "@availity/api-axios";

// src/lib/FeedbackForm.tsx
import { useEffect } from "react";
import { TextField } from "@availity/mui-textfield";
import { LoadingButton, Button, IconButton } from "@availity/mui-button";
import { ToggleButtonGroup, ToggleButton } from "@availity/mui-toggle-button";
import { Grid } from "@availity/mui-layout";
import { styled } from "@mui/material/styles";
import { FaceFrownIcon, FaceNeutralIcon, FaceSmileIcon } from "@availity/mui-icon";
import { FormLabel } from "@availity/mui-form-utils";
import { avRegionsApi } from "@availity/api-axios";
import { useForm, Controller } from "react-hook-form";
import { jsx, jsxs } from "react/jsx-runtime";
var SmileButtons = styled(ToggleButtonGroup, { name: "AvFeedbackContainer", slot: "SmileButtons" })({});
var FormActions = styled(Grid, { name: "AvFeedbackContainer", slot: "FormActions" })({});
var SmileButton = (_a) => {
  var _b = _a, { disabled, Icon, label, value } = _b, props = __objRest(_b, ["disabled", "Icon", "label", "value"]);
  return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
    ToggleButton,
    __spreadProps(__spreadValues({
      component: IconButton,
      disableRipple: true,
      title: label,
      "aria-label": value,
      value
    }, props), {
      disabled,
      size: "large",
      children: /* @__PURE__ */ jsx(Icon, {})
    })
  ) });
};
var FeedbackForm = ({
  analytics,
  appName,
  handleClose,
  loading,
  sent,
  setLoading,
  setSent
}) => {
  var _c;
  const {
    control,
    formState: { errors },
    handleSubmit,
    register,
    setValue,
    watch
  } = useForm();
  const onSubmit = (_a) => __async(void 0, null, function* () {
    var _b = _a, { smileField } = _b, values = __objRest(_b, ["smileField"]);
    setLoading(true);
    try {
      const response = yield avRegionsApi.getCurrentRegion();
      yield analytics.info(__spreadValues({
        surveyId: `${appName.replace(/\s/g, "_")}_Smile_Survey`,
        smileLocation: `${appName}`,
        smile: `icon-${smileField}`,
        url: window.location.href,
        region: response.data.regions[0] && response.data.regions[0].id,
        userAgent: window.navigator.userAgent,
        submitTime: /* @__PURE__ */ new Date()
      }, values));
      setSent(true);
      setLoading(false);
    } catch (e) {
      setSent(false);
      setLoading(false);
    }
  });
  useEffect(() => {
    if (sent) {
      setTimeout(() => {
        handleClose();
      }, 2e3);
    }
  }, [sent]);
  const options = [
    {
      Icon: FaceSmileIcon,
      label: "What do you like?",
      value: "smile"
    },
    {
      Icon: FaceNeutralIcon,
      label: "What would you improve?",
      value: "meh"
    },
    { Icon: FaceFrownIcon, label: "What don't you like?", value: "frown" }
  ];
  const smileFieldValue = watch("smileField");
  const getFeedbackLabel = () => {
    const option = options.find((option2) => option2.value === smileFieldValue);
    return (option == null ? void 0 : option.label) || "What would you improve?";
  };
  if (!sent) {
    return /* @__PURE__ */ jsxs(
      Grid,
      {
        component: "form",
        container: true,
        sx: { justifyContent: "center" },
        onSubmit: handleSubmit(onSubmit),
        "aria-label": "Feedback Form",
        "aria-describedby": "feedback-form-header",
        children: [
          /* @__PURE__ */ jsx(
            Controller,
            {
              control,
              name: "smileField",
              render: ({ field }) => {
                return /* @__PURE__ */ jsx(
                  SmileButtons,
                  __spreadProps(__spreadValues({
                    children: options.map((props, index) => /* @__PURE__ */ jsx(SmileButton, __spreadValues({ autoFocus: index === 0, disabled: loading }, props), props.value))
                  }, field), {
                    "aria-labelledby": "feedback-form-header",
                    onChange: (event, value) => {
                      setValue(field.name, value);
                    },
                    size: "medium",
                    exclusive: true
                  })
                );
              }
            }
          ),
          /* @__PURE__ */ jsx(
            TextField,
            __spreadProps(__spreadValues({}, register("feedback", {
              required: "This field is required",
              maxLength: { value: 200, message: "This field must not exceed 200 characters" }
            })), {
              fullWidth: true,
              multiline: true,
              minRows: 3,
              maxRows: 3,
              label: getFeedbackLabel(),
              InputLabelProps: {
                component: FormLabel,
                required: true
              },
              inputProps: { "aria-required": "true" },
              helperText: ((_c = errors.feedback) == null ? void 0 : _c.message) || "Max 200 characters",
              error: !!errors.feedback,
              disabled: loading || !smileFieldValue
            })
          ),
          /* @__PURE__ */ jsxs(FormActions, { container: true, direction: "row", width: "100%", spacing: 1, wrap: "wrap", children: [
            /* @__PURE__ */ jsx(Grid, { sx: { flex: 1, minWidth: "147px" }, children: /* @__PURE__ */ jsx(Button, { color: "secondary", disabled: loading, onClick: handleClose, children: "Close" }) }),
            /* @__PURE__ */ jsx(Grid, { sx: { flex: 1, minWidth: "147px" }, children: /* @__PURE__ */ jsx(LoadingButton, { disabled: !smileFieldValue, loading, type: "submit", variant: "contained", children: "Send Feedback" }) })
          ] })
        ]
      }
    );
  } else {
    return null;
  }
};

// src/lib/FeedbackHeader.tsx
import { IconButton as IconButton2 } from "@availity/mui-button";
import { CloseIcon } from "@availity/mui-icon";
import { Typography } from "@availity/mui-typography";
import { Grid as Grid2 } from "@availity/mui-layout";
import { styled as styled2 } from "@mui/material/styles";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var FeedbackHeaderContainer = styled2(Grid2, { name: "AvFeedbackContainer", slot: "FeedbackHeaderContainer" })({});
var FeedbackHeader = ({ appName, handleClose, loading, sent }) => {
  return /* @__PURE__ */ jsxs2(
    FeedbackHeaderContainer,
    {
      alignItems: "flex-start",
      container: true,
      direction: "row",
      justifyContent: "space-between",
      flexWrap: "nowrap",
      id: "feedback-form-header",
      children: [
        /* @__PURE__ */ jsx2(Grid2, { sx: { whiteSpace: "normal" }, children: /* @__PURE__ */ jsx2(Typography, { component: "h2", variant: "h5", children: sent ? "Thank you for your feedback." : `Tell us what you think about ${appName}` }) }),
        /* @__PURE__ */ jsx2(Grid2, { children: /* @__PURE__ */ jsx2(IconButton2, { disabled: loading, title: "Close", onClick: handleClose, size: "medium", children: /* @__PURE__ */ jsx2(CloseIcon, { fontSize: "xsmall" }) }) })
      ]
    }
  );
};

// src/lib/Feedback.tsx
import { CommentsIcon } from "@availity/mui-icon";
import { Fragment, jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var FeedbackContainer = styled3(Container, { name: "AvFeedbackContainer", slot: "root" })({});
var FeedbackButton = styled3(Button2, { name: "AvFeedbackButton", slot: "root" })({});
var Feedback = ({
  analytics = avLogMessagesApiV2,
  appName,
  buttonVariant = "secondary"
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setSent(false);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  return /* @__PURE__ */ jsxs3(Fragment, { children: [
    /* @__PURE__ */ jsx3(FeedbackButton, { onClick: handlePopoverOpen, color: buttonVariant, startIcon: /* @__PURE__ */ jsx3(CommentsIcon, {}), children: "Feedback" }),
    /* @__PURE__ */ jsx3(
      Popover,
      {
        anchorEl,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right"
        },
        sx: { marginTop: "4px" },
        disableRestoreFocus: true,
        onClose: handlePopoverClose,
        open,
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        children: /* @__PURE__ */ jsxs3(FeedbackContainer, { children: [
          /* @__PURE__ */ jsx3(FeedbackHeader, { appName, handleClose: handlePopoverClose, loading, sent }),
          /* @__PURE__ */ jsx3(
            FeedbackForm,
            {
              analytics,
              appName,
              handleClose: handlePopoverClose,
              loading,
              sent,
              setLoading,
              setSent
            }
          )
        ] })
      }
    )
  ] });
};
export {
  Feedback
};
